import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, IconButton } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import CustomForm from '../../../components/FormRenderer/CustomForm';
import { initializeFormData } from '../../../components/FormRenderer/utils';
import {
  createAkademyIndicatorStatutories,
  getAllAkademyIndicatorStatutories,
  getAllCurriculumFrameworks,
  updateAkademyIndicatorStatutories,
} from '../AkademySlice';

function AkademyIndicatorStatutories() {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  const { indicatorStatutories, frameworks } = useSelector(
    ({ akademyReducer }) => {
      return {
        indicatorStatutories: akademyReducer.indicatorStatutories,
        frameworks: akademyReducer.curriculumFrameworks,
      };
    }
  );
  useEffect(() => {
    dispatch(getAllAkademyIndicatorStatutories());
    dispatch(getAllCurriculumFrameworks());
  }, []);

  useEffect(() => {
    if (!frameworks) return;

    const formTemplate = [
      {
        id: 'form.framework',
        title: 'Framework',
        slug: 'frameworkId',
        type: 'Select',
        options: [
          ...frameworks.map(({ _id, name }) => {
            return { label: name, value: _id };
          }),
        ],
      },
      {
        id: 'form.type',
        title: 'Statutory Type',
        slug: 'type',
        type: 'String',
        required: true,
      },
    ];
    setFormTemplate(formTemplate);
    setFormData(initializeFormData(formTemplate));
  }, [frameworks]);

  const statutoryColumns = [
    { Header: 'Statutory Id', accessor: '_id' },
    { Header: 'Framework', accessor: 'framework' },
    { Header: 'Type', accessor: 'type' },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
            <IconButton disabled onClick={() => handleDeletion(_id)}>
              <DeleteIcon
                color="primary"
                style={{ color: 'grey', opacity: 0.5 }}
              />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    console.log(id);
    setSelectedRowId(id);
    const selectedDoc = indicatorStatutories.filter(({ _id }) => _id === id)[0];
    setFormData({ ...selectedDoc });
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    setFormData({});
    openFormModal();
  };

  const handleDeletion = async (id) => {
    // setSelectedRowId(id);
    // if (!window.confirm('Are you sure ?')) return;
    // dispatch(deleteAkademyClass({ id }))
    //   .unwrap()
    //   .then((res) => {
    //     console.log(res);
    //     SuccessToast(res.message);
    //     dispatch(getAllCurriculumFrameworks());
    //   })
    //   .catch((error) => {
    //     console.error('rejected', error);
    //     ErrorToast(error.message);
    //   });
  };

  const handleSave = async () => {
    handleLoader(true);
    let payload = formData;

    dispatch(
      selectedRowId === null
        ? createAkademyIndicatorStatutories(payload)
        : updateAkademyIndicatorStatutories(payload)
    )
      .unwrap()
      .then((res) => {
        console.log(res);
        SuccessToast(res.message);
        dispatch(getAllAkademyIndicatorStatutories());
        closeFormModal();
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box>
      <Button onClick={handleCreateNew} variant={'contained'} color="primary">
        Add Indicator Statutory
      </Button>
      <Box my={2}>
        <BuzzTable
          columns={statutoryColumns}
          data={indicatorStatutories}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'Indicator Statutory'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
}

export default AkademyIndicatorStatutories;
